/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ActionDataEditor } from './type';

/* 
Action Config
*/
export const delay = {
  key: 'delay',
  name: 'Delay',
  value: 0,
  min: 0,
  max: 2000,
  step: 100,
  valueType: 'ms',
  type: 'range',
};

export const duration = {
  key: 'duration',
  name: 'Duration',
  value: 500,
  min: 50,
  max: 2050,
  step: 50,
  valueType: 'ms',
  type: 'range',
};

const loop = {
  key: 'loop',
  name: 'Loop',
  type: 'checkbox',
  value: ['infinite'],
  options: [
    {
      value: 'infinite',
      text: 'Infinite',
    },
  ],
};

/* const screens = {
  key: "screens",
  name: "Trigger on",
  type: "checkbox",
  value: ["lg", "md", "sm", "xs"],
  options: [
    {
      value: "lg",
      text: "Desktop"
    },
    {
      value: "md",
      text: "Laptop"
    },
    {
      value: "sm",
      text: "Tablet"
    },
    {
      value: "xs",
      text: "Mobile"
    }
  ]
}; */

// const defaultOptionsEntrance = [delay, duration, screens];
const defaultOptionsEntrance = [delay, duration];

// const defaultOptionsStandInPlace = [delay, duration, loop, screens];
const defaultOptionsStandInPlace = [delay, duration, loop];

const animationsEntrance: ActionDataEditor[] = [
  {
    key: 'back',
    name: 'Back',
    type: 1,
    description: 'Object move in with smaller size and lower opactiy then back to normal',
    settings: [
      {
        key: 'direction',
        name: 'Direction',
        value: 'in-left',
        type: 'select',
        options: [
          {
            value: 'in-left',
            text: 'Left In',
          },
          {
            value: 'in-right',
            text: 'Right In',
          },
          {
            value: 'in-up',
            text: 'Top In',
          },
          {
            value: 'in-down',
            text: 'Bottom In',
          },
          {
            value: 'out-left',
            text: 'Left Out',
          },
          {
            value: 'out-right',
            text: 'Right Out',
          },
          {
            value: 'out-up',
            text: 'Top Out',
          },
          {
            value: 'out-down',
            text: 'Bottom Out',
          },
        ],
      },
    ],
  },
  {
    key: 'bounce',
    name: '(E) Bounce',
    type: 1,
    description: 'Bounce Object appear and bounce to normal position',
    settings: [
      {
        key: 'direction',
        name: 'Direction',
        value: 'in-left',
        type: 'select',
        options: [
          {
            value: 'in-left',
            text: 'Left In',
          },
          {
            value: 'in-right',
            text: 'Right In',
          },
          {
            value: 'in-up',
            text: 'Top In',
          },
          {
            value: 'in-down',
            text: 'Bottom In',
          },
          {
            value: 'out-left',
            text: 'Left Out',
          },
          {
            value: 'out-right',
            text: 'Right Out',
          },
          {
            value: 'out-up',
            text: 'Top Out',
          },
          {
            value: 'out-down',
            text: 'Bottom Out',
          },
        ],
      },
    ],
  },
  {
    key: 'fade',
    name: 'Fade',
    type: 1,
    description: 'Object stand in place and fade from 0% to 100% opacity',
    settings: [
      {
        key: 'direction',
        name: 'Direction',
        value: 'in-left',
        type: 'select',
        options: [
          {
            value: 'in-left',
            text: 'Left In',
          },
          {
            value: 'in-right',
            text: 'Right In',
          },
          {
            value: 'in-up',
            text: 'Top In',
          },
          {
            value: 'in-down',
            text: 'Bottom In',
          },
          {
            value: 'out-left',
            text: 'Left Out',
          },
          {
            value: 'out-right',
            text: 'Right Out',
          },
          {
            value: 'out-up',
            text: 'Top Out',
          },
          {
            value: 'out-down',
            text: 'Bottom Out',
          },
        ],
      },
    ],
  },
  {
    key: 'flip',
    name: 'Flip',
    type: 1,
    description: 'Object flip from the center (like a flipboard)',
    settings: [
      {
        key: 'direction',
        name: 'Flip',
        value: 'in-x',
        type: 'select',
        options: [
          {
            value: 'none',
            text: 'None',
          },
          {
            value: 'in-x',
            text: 'Flip In X',
          },
          {
            value: 'in-y',
            text: 'Flip In Y',
          },
          {
            value: 'out-x',
            text: 'Flip Out X',
          },
          {
            value: 'out-y',
            text: 'Flip Out Y',
          },
        ],
      },
    ],
  },
  {
    key: 'jack-in-the-box',
    name: 'Jack In the box',
    type: 1,
    description: 'Jack puppet effect',
  },
  {
    key: 'zoom',
    name: 'Zoom',
    type: 1,
    description: 'Object get bigger/smaller with fade effect',
    settings: [
      {
        key: 'direction',
        name: 'Flip',
        value: 'in',
        type: 'select',
        options: [
          {
            value: 'in',
            text: 'Zoom In',
          },
          {
            value: 'in-down',
            text: 'Zoom In Down',
          },
          {
            value: 'in-left',
            text: 'Zoom In Left',
          },
          {
            value: 'in-right',
            text: 'Zoom In Right',
          },
          {
            value: 'in-up',
            text: 'Zoom In Up',
          },
          {
            value: 'out',
            text: 'Zoom Out',
          },
          {
            value: 'out-down',
            text: 'Zoom Out Down',
          },
          {
            value: 'out-left',
            text: 'Zoom Out Left',
          },
          {
            value: 'out-right',
            text: 'Zoom Out Right',
          },
          {
            value: 'out-up',
            text: 'Zoom Out Up',
          },
        ],
      },
    ],
  },
  {
    key: 'slide',
    name: 'Slide',
    type: 1,
    description: 'Object slide in short distant',
    settings: [
      {
        key: 'direction',
        name: 'Direction',
        value: 'in-left',
        type: 'select',
        options: [
          {
            value: 'in-left',
            text: 'Left In',
          },
          {
            value: 'in-right',
            text: 'Right In',
          },
          {
            value: 'in-up',
            text: 'Top In',
          },
          {
            value: 'in-down',
            text: 'Bottom In',
          },
          {
            value: 'out-left',
            text: 'Left Out',
          },
          {
            value: 'out-right',
            text: 'Right Out',
          },
          {
            value: 'out-up',
            text: 'Top Out',
          },
          {
            value: 'out-down',
            text: 'Bottom Out',
          },
        ],
      },
    ],
  },
];

export const animationsStandInPlace: ActionDataEditor[] = [
  {
    key: 'bounce_',
    name: '(S) Bounce',
    type: 1,
    description: 'Bounce twice',
  },
  {
    key: 'flash',
    name: 'Flash',
    type: 1,
    description: 'Object stand in place and flash twice',
  },
  {
    key: 'pulse',
    name: 'Pulse',
    type: 1,
    description: 'Object scale bigger and smaller',
  },
  {
    key: 'rubber-band',
    name: 'Rubber band',
    type: 1,
    description: 'Rubber band Object animate like rubber band',
  },
  {
    key: 'shake-x',
    name: 'Shake X',
    type: 1,
    description: 'Object shake in horizontal',
  },
  {
    key: 'shake-y',
    name: 'Shake Y',
    type: 1,
    description: 'Object shake in vertical',
  },
  {
    key: 'swing',
    name: 'Swing',
    type: 1,
    description: 'Object stand in place and light swing',
  },
  {
    key: 'jello',
    name: 'Jello',
    type: 1,
    description: 'Jelly effect',
  },
  {
    key: 'heartbeat',
    name: 'Heartbeat',
    type: 1,
    description: 'Zoom in twice',
  },
];

/**
 * ..
 * @param list ..
 * @param settings ..
 * @returns ..
 */
const pushSettings = (list: ActionDataEditor[], settings: any): ActionDataEditor[] => {
  for (let i = 0; i < list.length; i++) {
    if (list[i].settings) {
      list[i].settings = [...list[i].settings, ...settings];
    } else {
      list[i].settings = settings;
    }
  }
  return list;
};
/**
 * animationsEntranceSettings
 * @returns ..
 */
export const animationsEntranceSettings = (): ActionDataEditor[] => {
  return pushSettings(animationsEntrance, defaultOptionsEntrance);
};

/**
 * animationsEntranceSettings
 * @returns ..
 */
export const animationsStandInPlaceSettings = (): ActionDataEditor[] => {
  return pushSettings(animationsStandInPlace, defaultOptionsStandInPlace);
};

export const animations: ActionDataEditor[] = [...animationsEntranceSettings(), ...animationsStandInPlaceSettings()];
